import React from 'react';

interface MemberAvatarProps {
  name: string;
  email: string;
  avatarUrl?: string;
  size?: number;
}

export const MemberAvatar: React.FC<MemberAvatarProps> = ({
  name,
  email,
  avatarUrl,
  size = 40
}) => {
  const getInitials = () => {
    if (name && name.trim() !== '') {
      const names = name.split(' ');
      if (names.length >= 2) {
        return `${names[0].charAt(0)}${names[1].charAt(0)}`.toUpperCase();
      }
      return name.charAt(0).toUpperCase();
    }
    return email.charAt(0).toUpperCase();
  };

  const getAvatarColor = (email: string) => {
    const colors = [
      'bg-blue-500', 'bg-indigo-500', 'bg-purple-500', 'bg-pink-500', 
      'bg-red-500', 'bg-orange-500', 'bg-amber-500', 'bg-yellow-500', 
      'bg-lime-500', 'bg-green-500', 'bg-emerald-500', 'bg-teal-500', 
      'bg-cyan-500'
    ];
    
    const hash = email.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0);
    return colors[hash % colors.length];
  };

  if (avatarUrl) {
    return (
      <img 
        className="rounded-full"
        src={avatarUrl}
        alt={name || email}
        style={{ width: size, height: size }}
      />
    );
  }

  return (
    <div 
      className={`rounded-full flex items-center justify-center text-white ${getAvatarColor(email)}`}
      style={{ width: size, height: size }}
    >
      <span className="text-sm font-medium">{getInitials()}</span>
    </div>
  );
};